import React from 'react'
import PropTypes from 'prop-types'
import { LayoutHeader, BreadCrumb } from '../../components'

import {
  PostLoginOuterWrapper,
  ContentInnerWrapper
} from './style'

const PostLogin = ({ pageTitle, children }) => {
  return (
    <PostLoginOuterWrapper>
      <LayoutHeader />
      <BreadCrumb pageTitle={pageTitle} />
      <ContentInnerWrapper>
        {children}
      </ContentInnerWrapper>
    </PostLoginOuterWrapper>
  )
}

PostLogin.propTypes = {
  pageTitle: PropTypes.string,
  children: PropTypes.node
}

PostLogin.displayName = 'PostLogin'

export default PostLogin
